import { render, staticRenderFns } from "./TableActionsMenu.vue?vue&type=template&id=2b88dfd0&"
import script from "./TableActionsMenu.vue?vue&type=script&lang=js&"
export * from "./TableActionsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports